import axiosInstance from '../../../helpers/backend_helper';

const deleteEpisodeById = async (id) => {
  try {
    const response = await axiosInstance.delete(`episodes/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting episode with ID ${id}:`, error);
    throw error;
  }
};

export default deleteEpisodeById;
